
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipl-indian-premier-league-2025",
      function () {
        return require("private-next-pages/ipl-indian-premier-league-2025/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ipl-indian-premier-league-2025"])
      });
    }
  